import React from 'react';
import { Button, ButtonGroup, Tooltip} from '@mui/material';

const CustomButtonGroup = (props) => {
    const { data, selected, handleClick, customStyle, isButtonWidthEqual = false, isToolTip = false } = props;
    const renderButton = (item, index) => {
        const label = isToolTip ? item.label : item;
        return (
            <Button
                key={index}
                onClick={() => handleClick(label)}
                disableRipple
                className="br-6px"
                sx={{
                    color: selected === label ? '#733567' : '#667085',
                    background: selected === label ? '#FAEDF9' : 'transparent',
                    fontFamily: 'Inter',
                    fontWeight: selected === label ? '600' : '500',
                    fontSize: '14px',
                    lineHeight: '20px',
                    textTransform: 'none',
                    '&:hover': {
                        borderColor: 'transparent',
                        backgroundColor: selected === label ? '#FAEDF9' : 'transparent',
                    },
                    '&:active': {
                        borderColor: 'transparent',
                        backgroundColor: selected === label ? '#FAEDF9' : 'transparent',
                    },
                    '&:focus': {
                        borderColor: 'transparent',
                        backgroundColor: selected === label ? '#FAEDF9' : 'transparent',
                    },
                    padding: '8px 12px',
                    borderRadius: selected === label ? '6px' : 'none',
                    alignSelf: 'stretch',
                }}
            >
                {label}
            </Button>
        );
    };

    return (
        <ButtonGroup
            aria-label="small button group"
            variant="outlined"
            sx={{
                background: 'transparent',
                borderRadius: '8px',
                '& .MuiButton-outlined': {
                    borderColor: 'transparent',
                },
                '&:hover': {
                    borderColor: 'transparent',
                },
                '.MuiButtonGroup-grouped:not(:last-of-type):hover': {
                    borderRightColor: 'transparent',
                },
                alignItems: 'center',
                padding: '4px',
                boxSizing: 'border-box',
                ...customStyle,
            }}
        >
            {data?.map((item, index) => (
                isToolTip ? (
                    <Tooltip title={item.definition} key={index}>
                        {renderButton(item, index)}
                    </Tooltip>
                ) : (
                    renderButton(item, index)
                )
            ))}
        </ButtonGroup>
    );
};

export default CustomButtonGroup;
